import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SelectItemTyped } from '../shared/dropdown/dropdown';
import { AvailableChartCurrenciesEnum, AvailableChartPeriodsEnum } from './rest-api/rest-api';

@Injectable({
  providedIn: 'root'
})
export class TranslatedConstantsService {
  public filtrableCurrencies: SelectItemTyped<AvailableChartCurrenciesEnum>[] = [];
  public filtrablePeriods: SelectItemTyped<AvailableChartPeriodsEnum>[] = [];

  public constructor(
    private translate: TranslateService,
  ) {}

  public initTranslatedConstants(): void {
    this.filtrableCurrencies = [
      {
        label: this.translate.instant('global.chartCurrencies.CZK'),
        value: AvailableChartCurrenciesEnum.CZK,
      },
      {
        label: this.translate.instant('global.chartCurrencies.percent'),
        value: AvailableChartCurrenciesEnum.PERCENT,
      }
    ];

    this.filtrablePeriods = [{
      label: this.translate.instant('global.chartPeriods.all'),
      value: AvailableChartPeriodsEnum.ALL,
    },
    {
      label: this.translate.instant('global.chartPeriods.1year'),
      value: AvailableChartPeriodsEnum.Y1,
    },
    {
      label: this.translate.instant('global.chartPeriods.3years'),
      value: AvailableChartPeriodsEnum.Y3,
    },
    {
      label: this.translate.instant('global.chartPeriods.5years'),
      value: AvailableChartPeriodsEnum.Y5,
    },
    {
      label: this.translate.instant('global.chartPeriods.ytd'),
      value: AvailableChartPeriodsEnum.YTD,
    },]
  }

  public getTranslatedPeriods(): SelectItemTyped<AvailableChartPeriodsEnum>[] {
    return this.filtrablePeriods;
  }

  public getTranslatedCurrencies(): SelectItemTyped<AvailableChartCurrenciesEnum>[] {
    return this.filtrableCurrencies;
  }
}
